import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SDQParent',
    label: 'SDQParent',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
